export default {
  id: null,
  tipo: null,
  dataInicial: null,
  descricao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/tiposfinalizacaomodel.js